export const playerKeys = {
  all: ['player'] as const,
  profile: (playerId?: string) => [...playerKeys.all, 'profile', playerId ?? null] as const,
  list: (request: player.SortFilterSearchPlayersRequest) =>
    [
      ...playerKeys.all,
      'list',
      request.academyId,
      request.sort,
      request.search ?? null,
      request.levelFilter ?? null,
      request.filterInactiveFor ?? null,
      request.pagination,
      request.resultsPerPage ?? null,
      request.expectedPage ?? null,
    ] as const,
} as const;
